import type {
  ContributorGroupPart,
  ContributorPart,
} from 'src/contracts/querySelections';

export const getContributorValue = (item: {
  contributors: ContributorPart[];
  contributorGroups: ContributorGroupPart[];
}) =>
  item.contributors.length || item.contributorGroups.length
    ? item.contributors
        .map((o) => o.user?.FriendlyName)
        .concat(item.contributorGroups.map((o) => o.group?.Name))
        .join(', ')
    : '-';
